import { Button, TextField } from "components";
import { useForm } from "hooks";
import { useState } from "react";
import { Actions, useAppDispatch, useAppSelector } from "store";
import { BaseModal } from "./BaseModal";

export const EditStepModal = () => {
    const step = useAppSelector((state) => state.ui.modals.editWizardStep.data);

    const form = useForm<Step>(step, {
        onSubmit: (values) => {},
    });

    const dispatch = useAppDispatch();

    const onCancel = () => {
        dispatch(Actions.ui.closeModal({ name: "editWizardStep" }));
    };

    const onSave = () => {
        if (!step) return;
        dispatch(
            Actions.agreementManager.updateStep({
                stepId: step.id,
                data: form.values,
            })
        );
        dispatch(Actions.ui.closeModal({ name: "editWizardStep" }));
    };

    return (
        <BaseModal>
            <form onSubmit={form.onSubmit} className="flex flex-col gap-8">
                <TextField name="name" placeholder={`Enter name`} onChange={form.onChange} value={form.values.name} />
                <div className="flex justify-between">
                    <Button onClick={onCancel}>Cancel</Button>
                    <Button type="submit" onClick={onSave}>
                        Save
                    </Button>
                </div>
            </form>
        </BaseModal>
    );
};
